import { CalensoFeature } from '@models/app.models';

const FUNCTIONS: CalensoFeature[] = [
  {
    identifier: 'termin-buchung',
    title: '1:1 Terminbuchung',
    description:
      'Bei Einzelterminen buchen Ihre Kunden eine oder mehrere Dienstleistungen. Somit kann pro Zeiteinheit nur eine Person an einem Termin teilnehmen.',
    icon: 'assets/icons/user.svg',
    image: 'assets/images/appointment-booking.webp',
  },
  {
    identifier: 'gruppentermine',
    title: 'Gruppentermine',
    description:
      'Gruppentermine ermöglichen die gleichzeitige Teilnahme mehrerer Personen an einem Termin, ideal für Kurse, Weiterbildungen, Webinare und Schulungen.',
    icon: 'assets/icons/seminar.svg',
    image: 'assets/images/group-session.webp',
  },
  {
    identifier: 'konferenztermine',
    title: 'Konferenztermine',
    description:
      'Schnelle Terminfindung für Meetings, die mehrere Teilnehmer erfordern, wie z.B. Vorstellungsgespräche mit Vorgesetzten, HR-Managern, Fachspezialisten & Bewerbern.',
    icon: 'assets/icons/crowd-of-users.svg',
    image: 'assets/images/conference-dates.webp',
  },
];

export type SiteKey = 'i' | 'l' | 'f' | 'b';
export type SiteType = 'insurance' | 'law' | 'finance' | 'banking';

const SITE_MAP: Record<SiteKey, SiteType> = {
  i: 'insurance',
  l: 'law',
  f: 'finance',
  b: 'banking',
};

const OV_BASE_URL = 'https://www.loom.com/embed/';
const OV_DEFAULT_ID = '969a26a42f164a63af5cfbef8443ad25';
const OV_FEATURES = ['Swiss Hosting', 'DSGVO konform', 'Enterprise ready', 'Customizable'];
const AGB_LINK = 'https://calenso.com/agb/';
const IMPRESSUM = 'https://calenso.com/impressum';

export {
  FUNCTIONS, OV_BASE_URL, OV_DEFAULT_ID, OV_FEATURES, SITE_MAP, AGB_LINK, IMPRESSUM };
